import { IoFileTrayOutline } from 'react-icons/io5';

import { Badge, Group } from '@mantine/core';

import { DashboardPanel } from 'components/dashboard-panel/DashboardPanel';
import { Inbox } from 'components/inbox/Inbox';
import { InboxActions } from 'components/inbox/InboxActions';
import { useInbox } from 'hooks/use-inbox';

const DashboardInbox = () => {
    const { unreadCount } = useInbox();

    return (
        <DashboardPanel
            icon={<IoFileTrayOutline />}
            color="red"
            title={
                <Group gap={6} wrap="nowrap">
                    Inbox
                    {unreadCount > 0 && (
                        <Badge size="xs" variant="filled" px={4} miw={16} color="red">
                            {unreadCount}
                        </Badge>
                    )}
                </Group>
            }
            rightSection={<InboxActions />}
            flushBottom
        >
            <Inbox maxHeight={720} />
        </DashboardPanel>
    );
};

export { DashboardInbox };
